import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Microphone = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12.497 6.053a25.9 25.9 0 0 0 5.623 5.142m-4.811 2.232-5.09 3.925a2.363 2.363 0 0 1-3.147-.174l-.006-.006a2.364 2.364 0 0 1-.175-3.148L8.81 8.93m-4.154 8.63a2.243 2.243 0 1 0 3.173 3.173l1.59-1.586a3.367 3.367 0 0 1 4.759 0M20.24 7.182a5.182 5.182 0 1 1-10.364 0 5.182 5.182 0 0 1 10.364 0"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Microphone) as SvgIcon;
export { ForwardRef as ReactComponent };
